
import React, {useEffect, useState} from "react";
import {Box, Button} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ShareIcon from "app/pages/Docgen/components/common/icons/ShareIcon";
import MuiTableWrapper from "app/pages/Docgen/components/common/mui-table-wrapper/MuiTableWrapper";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import DifferenceOutlinedIcon from "@mui/icons-material/DifferenceOutlined";
import UpdateStatus from "app/pages/Docgen/components/common/update-status/UpdateStatus";
import useSweetAlert from "app/pages/Docgen/components/common/alert/useSweetAlert";
import SendForSignature from "app/pages/Docgen/components/common/send-for-signature/SendForSignature";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import UpdateFileStatus from "app/pages/Docgen/components/common/update-file-status/updateFileStatus";
import FormSearchFilter from "app/pages/Docgen/components/common/form-search-filter/FormSearchFilter";
import FallbackGeneratedFormMessage from "app/pages/Docgen/components/common/fallback-form-message/FallbackGeneratedFormMessage";
import useToaster from "app/pages/Docgen/components/common/toaster/useToaster";
import {del, get, post, put} from "../../../common/network";
import {Date_format, DateFormatter} from "app/pages/Docgen/constants/date_format";
import {toast} from "react-toastify";
import FilingDocumentModal from "../../../components/filing/FilingDocumentsModal";
import CircularProgress from "@mui/material/CircularProgress";
import UpdateWorkbenchStatus from "../../../components/common/update-status/UpdateWorkbenchStatus";

const WorkbenchTab = ({id, isMatterDetails}) => {
  //#region for states
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [items, setItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isRowId, setIsRowId] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState([]);

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [formTypeValue, setFormTypeValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [rowsSelection,setRowsSelection] = useState([]);
  const [filingDocumentModalOpen,setFilingDocumentModalOpen] = useState(false);
  const [clickedFileData,setClickedFileData] = useState({});
  const [updateParameters,setUpdateParameters] = useState({status:"",filing_date:"",remarks:""});
  const [statusLoading,setStatusLoading] = useState(false);
  const [deleteLoading,setDeleteLoading] = useState(false);
  //#endregion

  //#region for hooks
  const sweetAlert = useSweetAlert();
  //#endregion

  // HANDLE DELETE FUNCTION
  const handleDelete = () => {
    sweetAlert({
      text: "Are you sure you want to delete the selected record(s) ?",
      icon: "warning",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed == true) {
        deleteMatter(result);
      }
    });
  };

  const handleUpdateStatus = () => {
    setIsModalOpen(true);
  };
    //#endregion

  const deleteMatter = async () => {

    try {
      setDeleteLoading(true);
      const selectedIds = [];
      for (const row of selectedRows) {
        selectedIds.push(row.id);
      }
      const response = await del(`docgen/filing/delete`, {
        selectedIds: selectedIds,
      });
      toast.success(response.message);
      fetchData();
    } catch (error) {
    }
    finally {
      setDeleteLoading(false);
      setSelectedRows([]);
      setRowsSelection([]);
    }
  };

  // HANDLE DOWNLOAD FUNCTION
  const handleDownload = () => {
    downloadForms();
  };

  const isStatusUpdateAllowed = selectedRows.every(row => row.status !== "Filed");

  const downloadForms = async () => {
  try {
    setIsLoading(true);
    const selectedIds = [];

    for (const row of selectedRows) {
      selectedIds.push(row.id);
    }
    const response = await get(
      `docgen/filed-documents-bulk/download`,{
          params: {selectedIds: JSON.stringify(selectedIds)},
          responseType: "blob",
      },
      false
    );

    // Get the current timestamp
    const timestamp = new Date().getTime();

      const contentDispositionHeader =
        response?.headers["content-disposition"];
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDispositionHeader);
      let suggestedFilename;
      if (selectedIds.length!==1) {
          suggestedFilename = `forms-${timestamp}.zip`;
      } else {
          suggestedFilename = matches && matches[1] && matches[1].replace(/['"]/g, "");
      }
      
      // Create a Blob from the response content
      const mimeType = response?.headers["content-type"];
      const blob = new Blob([response.data], {type: mimeType});

      // Create a URL for the blob response
      const url = URL.createObjectURL(blob);

      // Create a hidden anchor element
      const anchor = document.createElement("a");
      anchor.style.display = "none";
      anchor.href = url;
      anchor.download = suggestedFilename; // Set the desired file name

      // Append the anchor to the document body
      document.body.appendChild(anchor);

      // Simulate a click on the anchor to trigger the download
      anchor.click();

      // Remove the anchor from the document body
      document.body.removeChild(anchor);
   
  } catch (error) {
  } finally {
    setIsLoading(false);
  }
  };

  //#endregion

  //#region for column declaration
  const columns = [
    {
      field: "host_file_number",
      header: "Docket No.",
      render: (value, row) => {
        return (
          <Button
            variant="text"
            onClick={() => {
              setIsRowId(row?.matterData?.id);
            }}
            className="listing-btn"
          >
            {row?.matterData?.host_file_number}
          </Button>
        );
      },
    },
    {
      field: "workbenchId",
      header: "Workbench Id",
      render: (value, row) => {
        return row?.workbenchId;
      },
    },
    {
      field: "user_name",
      header: "User's Name",
      render: (value, row) => {
        return `${row?.user?.first_name} ${row?.user?.last_name}`;
      },
    },
    {
        field: "action",
        header: "Action",
        render: (value,row) => {
          return <InsertDriveFileOutlinedIcon onClick={()=> handleActionButton(row.id)} sx={{cursor:"pointer"}}/>;
        },
    },
    {
      field: "created_at",
      header: "Created At",
      render: (value,row) => {
        if (row?.createdAt) {
          const date = new Date(row?.createdAt); 
        return DateFormatter(date);
        } else return null;
        
      },
    },
  ];

  const handleActionButton = (rowId) =>{
    const selectedFiledData = data?.find((row)=> row.id === rowId) || [];
    setClickedFileData(selectedFiledData);
    setFilingDocumentModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // Handle search with the latest input and option values
  useEffect(() => {
    handleSearch();
  }, [inputValue, selectedOption]);

  const handleSearch = (value) => {
    const columnName = value?.value || ""; // Name of the column
    const searchValue = value?.searchedText || ""; // Value entered in the input field
    const dropdownValue = value?.dropdownValue || ""; // value selected in the dropdown field
    setSearchValue(searchValue);
    setFilterText(columnName);
    setFormTypeValue(dropdownValue);
    
    if (columnName === "updated_at" || columnName === "filing_date") {
      setDateValue(value);
    }
  };

  const fetchData = async () => {
    setIsFetching(true);          
    try {
      const response = await get(`docgen/filing`);
      const filteredData = response?.filter((p)=> p.matterData?.id === id && p.status !== "Filed");
      setData(filteredData);
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  const handleSubmit = async (parameters) => {
    setStatusLoading(true);
    const selectedIds = selectedRows.map((row)=> row.id);
    try {
      const response = await put(`docgen/workbench-status`, {
       selectedIds, 
       parameters : parameters
      });
      toast.success(response.message);
      fetchData();
    } catch (error) {
    } finally {
      setSelectedRows([]);
      setRowsSelection([])
      setStatusLoading(false);
    }
  };

  useEffect(()=>{
    fetchData();
  },[])


  return (
    <div className="page-content-wrapper">
      <Box className="w-100">
        <header className="section-heading">
          <div className="left-area">
          <FormSearchFilter
              options={[
                { value: "all", label: "All" },
                { value: "host_file_number", label: "Docket No." },
                { value: "user_name", label: "User's Name" },
                { value: "filing_date", label: "Date of Filing" },
              ]}
              dateFiltersOptionsValueArray={["filing_date"]}
              onSearch={(values) => handleSearch(values)}
              defaultOption = { {value: "", label: "Select an option"} }
            />
          </div>
          <div className="right-area">
            <section className="top-actions-section">
              <div className="buttons-group">
                {selectedRows.length > 0 && (
                  <ul>
                    <li>
                      <Button type="button" onClick={handleDelete}>
                        {deleteLoading ?  <CircularProgress sx={{ color: "blue" }} />:
                        <>
                        <div className="icon-area">
                          <DeleteOutlineOutlinedIcon />
                        </div>
                        <p className="text-area">Delete</p>
                        </>}
                      </Button>
                    </li>
                    <li>
                      {isStatusUpdateAllowed && <Button type="button" onClick={handleUpdateStatus}>
                        {statusLoading ? <CircularProgress sx={{ color: "blue" }} />:
                        <>
                        <div className="icon-area">
                          <AutorenewOutlinedIcon />
                        </div>
                        <p className="text-area">Update Status</p>
                        </>}
                      </Button>}
                    </li>
                    <li>
                        <Button type="button" onClick={() => handleDownload()}>
                            {isLoading ?  <CircularProgress sx={{ color: "blue" }} />:
                            <>
                            <FileDownloadOutlinedIcon />
                                <p className="text-area">Download</p>
                            </>}
                        </Button>
                    </li>
                  </ul>
                )}
              </div>
            </section>
          </div>
        </header>
        <div id="forms-tab" name="forms-tab">
          <MuiTableWrapper
            columns={columns}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            emptyBody={
              <FallbackGeneratedFormMessage searchedKeyword={searchValue} />
            }
            setItems={setItems}
            setForm={setForm}

            searchValue={searchValue}
            filterColumn={filterText}
            formTypeValue={formTypeValue}
            data={data}
            isFetching={isFetching}
            dateValue={dateValue}
            rowsSelection={rowsSelection}
            setRowsSelection={setRowsSelection}
          />
        </div>
      </Box>

{
        <UpdateWorkbenchStatus
          isModalOpen={isModalOpen}
          handleModalClose={handleModalClose}
          handleSubmit={handleSubmit}
          selectedRows={selectedRows}
          updateParameters={updateParameters}
          setUpdateParameters={setUpdateParameters}
        />
      }

     
         {
        <FilingDocumentModal 
            filingDocumentModalOpen={filingDocumentModalOpen}
            setFilingDocumentModalOpen={setFilingDocumentModalOpen}
            clickedFileData={clickedFileData}
        />
      }
    </div>
  );
};

export default WorkbenchTab;